import { RuleResult } from 'types/DeclarationP5'
import { AUTHORISATION_TYPE_CODE_PREFIX, removePrefix } from 'shared/ncts/common/classifier-util'
import { Authorisation } from '../../common/types'

const C0839Validator = {
  validateLimitDateRequirement: ({
    additionalDeclarationType,
    authorisations,
  }: {
    additionalDeclarationType: string
    authorisations: Authorisation[]
  }): RuleResult => {
    if (authorisations.length === 0) {
      return 'NOT_ALLOWED'
    }

    if (authorisations.some((auth) => removePrefix(auth?.type ?? null, AUTHORISATION_TYPE_CODE_PREFIX) === 'C521')) {
      if (additionalDeclarationType === 'D') {
        return 'OPTIONAL'
      }

      return 'REQUIRED'
    }
    return 'NOT_ALLOWED'
  },

} as const

export default C0839Validator
